import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Shield } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { apiClient, useAuth } from "../App";
import { toast } from "sonner";

const ALLOWED_PLANS = ["free", "pro", "full_access"];
const AdminPlanAccessPage = () => {
  const navigate = useNavigate();
  const { setUser, checkAuth, user } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [pin, setPin] = useState(localStorage.getItem("admin_plan_pin") || "");
  const [loading, setLoading] = useState(false);
  const [authorized, setAuthorized] = useState(false);

  const activatePlanMode = async (selectedPlan) => {
    if (!pin.trim()) {
      toast.error("Code PIN requis");
      return;
    }
    localStorage.setItem("test_plan_override", selectedPlan);
    localStorage.setItem("admin_plan_pin", pin.trim());
    localStorage.setItem("plan_override_enabled", "true");
    if (user) {
      setUser({ ...user, plan: selectedPlan });
    }
    await checkAuth();
    toast.success(`Mode ${selectedPlan} actif sur tout le site`);
    navigate("/dashboard");
  };

  const clearPlan = () => {
    localStorage.removeItem("test_plan_override");
    localStorage.removeItem("test_admin_key");
    localStorage.removeItem("admin_plan_pin");
    localStorage.removeItem("plan_override_enabled");
    setPin("");
    toast.success("Mode debug nettoye");
  };

  const handleAdminLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await apiClient.post("/auth/login", {
        email: email.trim(),
        password,
      });

      const token = response?.data?.token;
      const user = response?.data?.user || {};
      if (token) {
        localStorage.setItem("auth_token", token);
      }
      setUser(user);

      setAuthorized(true);
      toast.success("Connexion admin OK");
    } catch (error) {
      const message = error.response?.data?.detail || "Echec de connexion admin";
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#111111] flex items-center justify-center px-6">
      <div className="w-full max-w-md bg-[#111111] border border-[#1F1F1F] rounded-2xl p-6">
        <Button
          variant="ghost"
          className="mb-4 text-zinc-400 hover:text-white"
          onClick={() => navigate("/")}
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Retour
        </Button>

        <div className="flex items-center gap-2 mb-4">
          <Shield className="w-5 h-5 text-[#7C3AED]" />
          <h1 className="text-xl font-bold text-white">Admin Plan Debug</h1>
        </div>

        {!authorized ? (
          <form onSubmit={handleAdminLogin} className="space-y-4">
            <div>
              <Label className="text-zinc-300">Adresse email</Label>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="bg-[#111111] border-[#1F1F1F] text-white"
                required
              />
            </div>
            <div>
              <Label className="text-zinc-300">Mot de passe</Label>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="bg-[#111111] border-[#1F1F1F] text-white"
                required
              />
            </div>
            <Button
              type="submit"
              className="w-full bg-[#7C3AED] hover:bg-[#6D28D9] text-white"
              disabled={loading}
            >
              {loading ? "Connexion..." : "Se connecter (admin)"}
            </Button>
          </form>
        ) : (
          <div className="space-y-4">
            <div>
              <Label className="text-zinc-300">Code PIN admin</Label>
              <Input
                type="password"
                value={pin}
                onChange={(e) => setPin(e.target.value)}
                className="bg-[#111111] border-[#1F1F1F] text-white"
                placeholder="PIN secret"
                required
              />
            </div>
            <p className="text-xs text-zinc-500">
              Clique directement sur un plan: tout le site passera dans ce mode.
            </p>
            {ALLOWED_PLANS.map((item) => (
              <Button
                key={item}
                className="w-full bg-[#7C3AED] hover:bg-[#6D28D9] text-white"
                onClick={() => activatePlanMode(item)}
              >
                Entrer en mode {item}
              </Button>
            ))}
            <Button variant="ghost" className="w-full text-zinc-300 hover:text-white" onClick={clearPlan}>
              Desactiver override
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminPlanAccessPage;
